/**
 * File: src/utils/accessibility.js
 * Mô tả: Các tiện ích hỗ trợ khả năng truy cập (Accessibility/a11y), quản lý focus và khóa cuộn trang.
 * Liên quan: src/components/game-detail-modal.js, src/components/lightbox.js, src/state/modal-state.js
 */

/** @type {HTMLElement|null} */
let previousActiveElement = null;

/**
 * Khóa cuộn trang khi mở Modal hoặc Lightbox
 */
export const lockScroll = () => {
  document.body.style.overflow = 'hidden';
};

/**
 * Mở lại cuộn trang khi đóng Modal
 */
export const unlockScroll = () => {
  document.body.style.overflow = '';
};

/**
 * Lưu lại phần tử đang focus trước khi mở Modal
 */
export const saveFocus = () => {
  previousActiveElement = document.activeElement;
};

/**
 * Khôi phục lại focus trước đó khi đóng Modal
 */
export const restoreFocus = () => {
  if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
    previousActiveElement.focus();
    previousActiveElement = null;
  }
};

/**
 * Bẫy focus bên trong container Modal để hỗ trợ điều hướng bàn phím (Tab / Shift+Tab)
 * @param {HTMLElement} containerElement 
 * @param {KeyboardEvent} event 
 */
export const handleFocusTrap = (containerElement, event) => {
  if (event.key !== 'Tab') return;

  const focusableElements = containerElement.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  
  if (focusableElements.length === 0) return;

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  if (event.shiftKey) {
    if (document.activeElement === firstElement) {
      lastElement.focus();
      event.preventDefault();
    }
  } else {
    if (document.activeElement === lastElement) {
      firstElement.focus();
      event.preventDefault();
    }
  }
};
